import React, { useEffect, useState } from "react";
import { URL } from "../Redux/common/url";

const VideoCards = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch(`${URL.API_BASE_URL}/publicApi/shortsListPublic`)
      .then((res) => res.json())
      .then((data) => {
        console.log("API DATA:", data); // 🔥 debug

        if (data?.success) {
          // ✔ team ya docs dono handle
          setVideos(data.shorts || data.docs || []);
        }
      })
      .catch((err) => console.log("API Error:", err));
  }, []);

  // 🔥 YouTube URL → Embed (safe version)
  const getEmbedUrl = (url) => {
  if (!url) return "";

  try {
    let videoId = "";

    if (url.includes("shorts/")) {
      videoId = url.split("shorts/")[1].split("?")[0];
    } else if (url.includes("watch?v=")) {
      videoId = url.split("watch?v=")[1].split("&")[0];
    } else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    }

    return videoId
      ? `https://www.youtube.com/embed/${videoId}?rel=0`
      : "";
  } catch {
    return "";
  }
};

  return (
    <div className="container-fluid py-5 bg-light px-4">

      {/* 🔥 Heading */}
      <div className="text-center mb-4">
        <h1 className="fw-bold">Our Videos</h1>
        <div
          style={{
            width: "80px",
            height: "3px",
            background: "#dc3545",
            margin: "8px auto",
            borderRadius: "2px",
          }}
        ></div>
      </div>

      <div className="row g-4">
        {videos.length === 0 && (
          <p className="text-center text-muted">No Videos Found</p>
        )}

        {videos.map((video, index) => {
          const embedUrl = getEmbedUrl(video.video_link);

          // 🔥 debug (temporary)
          console.log("Video Link:", video.video_link);

          return (
            <div key={index} className="col-12 col-md-6 col-lg-3">
              <div className="card shadow rounded-3 border-0 h-100">

                {/* ❗ iframe fix (ratio hata diya) */}
                {embedUrl ? (
                  <iframe
                    src={embedUrl}
                    title={`video-${index}`}
                    style={{
                      width: "100%",
                      height: "220px",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <div className="p-3 text-danger">
                    Invalid Video Link
                  </div>
                )}

                <div className="card-body">
                  <h6 className="fw-semibold">
                    {video.title || "Video Title"}
                  </h6>

                  <p className="text-muted small">
                    {video.short_description || "No Description"}
                  </p>

                  {/* 🔥 Direct open button */}
                  {video.video_link && (
                    <a
                      href={video.video_link}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-danger btn-sm"
                    >
                      ▶ Watch Video
                    </a>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VideoCards;